// extracted by mini-css-extract-plugin
export default {"w-full":"ImagesAndCTA_w-full__OST6Y","field":"ImagesAndCTA_field__f+B3Q"};